<template>
  <div v-if="weather != null && weather.weather != null && weather.main != null" class="weather_container">
    <div class="weather_container_inner">
      <table>
        <tr>
          <td style="padding-top: 10px; width: 80%;">
            <b>
              <span v-if="weather != null && weather.name != null">
                {{ weather.name }} 
              </span>
              <span v-if="weather != null && weather.sys != null && weather.sys.country != null">
                {{ weather.sys.country }}
              </span>
            </b>
            <span v-if="weather != null && weather.main != null && weather.main.temp != null">
              {{ (Math.round(weather.main.temp)) }}c
            </span>
          </td>
          <td rowspan="2">
            <span v-if="weather != null && weather.weather != null">
              <img v-bind:src="'http://openweathermap.org/img/w/' + weather.weather[0].icon + '.png'" /> 
            </span>
          </td>
          <td rowspan="2">
            <span class="is-size-5 is-pulled-right">
              <a @click="$emit('remove')" style="color: red;" title="Remove Weather">
                <i class="fas fa-times-circle"></i>
              </a>
            </span>
          </td>
        </tr>
        <tr>
          <td style="font-style: italic;">
            <p class="weather_container_subtitle">
              <span v-if="weather != null && weather.weather != null">
                {{ weather.weather[0].description }}, 
              </span>
              <span v-if="weather != null && weather.wind != null && weather.wind.speed != null">
                wind {{ Math.round(weather.wind.speed) }}km/h
              </span>
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Weather',
  props: {
    weather: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.weather_container {
  background-color: #2e7d32;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 16px;
}
.weather_container_inner {
  color: white;
}
.weather_container_subtitle {
  font-size: 0.9em;
  color: #e0e0e0;
}
table {
  width: 100%;
}
</style>
